import { withDefault } from '@vy/utils';
import { useEffect, useRef } from 'react';
import { usePageParam } from './search-params/use-page-param';
import { usePageSizeParam } from './search-params/use-page-size-param';

export function usePaginationResetHandler(itemsLength: number, isLoading = false) {
  const [page, setPage] = usePageParam();
  const [pageSize] = usePageSizeParam();
  const hasLoadedOnce = useRef(false);

  useEffect(() => {
    if (itemsLength > 0) {
      hasLoadedOnce.current = true;
    }
  }, [itemsLength]);

  useEffect(() => {
    if (isLoading || !hasLoadedOnce.current) {
      return;
    }

    const currentPage = withDefault(page, 0);

    if (currentPage > 0 && itemsLength === 0) {
      setPage(0);
    }
  }, [itemsLength, page, pageSize, setPage, isLoading]);
}
